import { render, staticRenderFns } from "./clipboard-icon.vue?vue&type=template&id=372f8174"
import script from "./clipboard-icon.vue?vue&type=script&lang=js"
export * from "./clipboard-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports